/**
 * @deprecated Use `ReservationStatusCode` from 'src/types/drive-detail' instead
 */
export enum ReservationStatusCode {
  RESERVATION_FAILED = 1, // 予約失敗
  RESERVATION_COMPLETED = 2, // 予約完了
  RESERVATION_CANCELED_BEFORE_DEADLINE = 3, // 予約キャンセル （締切前）
  RESERVATION_CANCELED_AFTER_DEADLINE = 4, // 予約キャンセル（締切後）
  VEHICLE_APPROCHING = 5, // 配車中
  VEHICLE_ARRIVED = 6, // 車両到着済
  RIDING = 7, // 乗車中
  RIDE_COMPLETED = 8, // 降車完了
  DRIVE_CANCEL = 9, // ドライバキャンセル
  OPERATOR_CANCEL_BEFORE_DEADLINE_DRIVER_ADMIN = 10, // 締切前オペレータキャンセル（ドライバ管理者）
  OPERATOR_CANCEL_AFTER_DEADLINE_DRIVER_ADMIN = 11, // 締切後オペレータキャンセル（ドライバ管理者）
  OPERATOR_CANCEL_BEFORE_DEADLINE_SERVICE_PROVIDER = 12, // 締切前オペレータキャンセル（サービス事業者）
  OPERATOR_CANCEL_AFTER_DEADLINE_SERVICE_PROVIDER = 13, // 締切後オペレータキャンセル（サービス事業者）
  SYSTEM_CANCEL = 14, // システムキャンセル
}

/**
 * @deprecated Use `RouteStatus` from 'src/types/drive-detail' instead
 */
export enum RouteStatus {
  RUNNING = 'running', // 運行中
  FINISHED = 'finished', // 運行済み
  SCHEDULED = 'scheduled', // 運行予定
}

/**
 * @deprecated Use `ReservationStatusCodeUpdateRequest` from 'src/types/drive-detail' instead
 */
export type ReservationStatusCodeUpdateRequest = {
  reservationIdList: { reservationId: number }[]; // 配車予約IDリスト
  reservationStatusCode: number; // 配車予約ステータスコード
  payMethodCode?: number; // 決済方法コード
  isNotification?: boolean; // 通知要否フラグ
};

/**
 * @deprecated Use `DriveDetail` from 'src/types/drive-detail' instead
 */
export type DriveDetail = {
  vehicleOperationScheduleId: number; // 車両運行便ID
  operationScheduleId: number; // 運行便ID
  operationScheduleName: string; // 運行便名
  operationZoneId: number; // 運行区域ID
  operationZoneName: string; // 運行区域名
  direction: string; // 方面
  date: string; // 日付
  driveReservationCount: number; // ドライブ組数
  drivePassengerCount: number; // ドライブ人数
  drivePrice: number; // ドライブ料金
  actualOperationEndDateTime: string; // 運行終了実績日時
  reservationList: Reservation[]; // 配車予約リスト
};

/**
 * @deprecated Use `OperationFinishConfirmData` from 'src/types/drive-detail' instead
 */
export type OperationFinishConfirmData = {
  vehicleOperationScheduleId: number; // 車両運行便ID
  operationScheduleId: number; // 運行便ID
  operationScheduleName: string; // 運行便名
  operationZoneId: number; // 運行区域ID
  operationZoneName: string; // 運行区域名
  direction: string; // 方面
  date: string; // 日付
  driveReservationCount: number; // ドライブ組数
  drivePassengerCount: number; // ドライブ人数
  drivePrice: number; // ドライブ料金
  detail: TimeInformation[];
};

/**
 * @deprecated Use `Reservation` from 'src/types/drive-detail' instead
 */
export type Reservation = {
  isShow: boolean;
  reservationId: number; // 配車予約ID
  status: string; // ステータス
  userId: number; // ユーザID
  gender: number; // 性別
  userName: string; // ユーザ名
  address: string; // 住所
  pickupWaypointId: number; // 乗車地点ID
  pickupWaypointNumber: string; // 乗車地点番号
  pickupWaypointName: string; // 乗車地点名
  pickupLatitude: string; // 乗車緯度
  pickupLongitude: string; // 乗車経度
  pickupWaypointSequence: string; // 乗車地点順序
  estimatedPickupDatetime: string; // 乗車予定日時
  latestEstimatedPickupDatetime: string; // 最新乗車予定日時
  dropoffWaypointId: number; // 降車地点ID
  dropoffWaypointNumber: string; // 降車地点番号
  dropoffWaypointName: string; // 降車地点名
  dropoffLatitude: string; // 降車緯度
  dropoffLongitude: string; // 降車経度
  dropoffWaypointSequence: string; // 降車地点順序
  estimatedDropoffDatetime: string; // 降車予定日時
  latestEstimatedDropoffDatetime: string; // 最新降車予定日時
  price: number; // 乗車合計料金
  paymentMethod: number; // 決済方法
  allowedPaymentMethods: number[]; // areaごとに車内決済で許可されている決済方法リスト
  message: string; // 伝達事項
  passengerTypeList: Passenger[]; // 乗客種別リスト
};

/**
 * @deprecated Use `TimeInformation` from 'src/types/drive-detail' instead
 */
export type TimeInformation = {
  key?: number;
  time: string;
  waypointId: number;
  waypointName: string;
  waypointSequence: string;
  latitude: string;
  longitude: string;
  timeDiff?: number;
  pickup: Reservation[];
  dropoff: Reservation[];
};

/**
 * @deprecated Use `StationState` from 'src/types/drive-detail' instead
 */
export type StationState = {
  [key: string]: {
    hasArrived: boolean; // 車両到着カード操作を完了 true
    pickUpArrivalClicked: boolean; // 乗車地点到着ボタン押下 true
  };
};

/**
 * @deprecated Use `generateStationKey` from 'src/types/drive-detail' instead
 */
export const generateStationKey = (waypointId: number, pickUpArrivalTime: string, waypointSequence: string): string =>
  `${waypointId}-${pickUpArrivalTime}-${waypointSequence}`;

/**
 * @deprecated Use `ReservationState` from 'src/types/drive-detail' instead
 */
export type ReservationState = {
  [reservationId: number]: {
    isPickUpCompleted: boolean; // 乗車カード操作を完了 true
    isDropOffCompleted: boolean; // 降車カード操作を完了 true
    pickUpClicked: boolean; // 乗車ボタン押下 true
    cancelClicked: boolean; // ドライバキャンセルボタン押下 true
    dropOffClicked: boolean; // 降車ボタン押下 true
  };
};

/**
 * 乗客人数情報
 */
/**
 * @deprecated Use `Passenger` from 'src/types/drive-detail' instead
 */
export type Passenger = {
  passengerTypeId: number; // 乗客種別ID
  passengerTypeName: string; //  乗客種別名
  passengerCount: number; // 乗車人数
};
